<template lang="pug">
  h1.logo
    span.ble(:style="fontstyle", v-html="brText", ref="txt", :class="{moving: config.moving}")

</template>

<script>
  import { mapState } from 'vuex'

  export default  {
    name: 'transition-logo',
    data(){
      return {
        fontstyle: ''
      }
    },
    props: {
      size: {
        type: String,
        default: '2rem'
      },
      text: {
        type: String,
        default: 'Transition'
      },
      maxWidth: {
        type: Number,
        default: window.innerWidth > 0 ? window.innerWidth : document.documentElement.clientHeight
      }
    },
    methods: {
      getLongestPhrase(){
        const text = this.text.trim()
        const arr = text.split(' ')
        const longest = arr.reduce((a, b) => {
          return a.length > b.length ? a : b
        }, '')
        return longest
      },
      calcStyleSize() {
        let size = this.size
        if(this.size.includes('rem')){
          size = (parseInt(this.size, 10) * 16 )
        } else {
          size = (parseInt(this.size), 10)
        }
        const windowWidth = window.innerWidth > 0 ? window.innerWidth : document.documentElement.clientHeight
        const maxWidth = this.maxWidth > 0 ? this.maxWidth : windowWidth
        // console.log('windowWidth', windowWidth)

        const longest = this.getLongestPhrase()
        const padding = 20;
        const canvas = document.createElement('canvas')
        canvas.id = `canv${Math.random() * (100-1) + 1}`
        canvas.width = 0
        canvas.height = 0
        document.body.appendChild(canvas)
        const c = document.getElementById(canvas.id)
        const context = c.getContext('2d')
        context.font = `${size}px "LaTercera"`
        const text = context.measureText(longest.toUpperCase())
        // console.log(text.width, maxWidth)
        if(text.width + padding >= maxWidth){
          size = maxWidth / longest.length
          // console.log('maxnew', size)
        }
        return `font-size: ${size}px; padding: calc(${size}px * 0.3) 0 0 0 ; letter-spacing: calc(${size}px * 0.08)`
      }
    },
    computed: {
      brText(){
        const text = this.text.trim()
        return text.replace(' ', '<br>')
      },
      ...mapState([
        'config'
      ])
    },
    mounted(){
      this.fontstyle = this.calcStyleSize()
    }
  }
</script>

<style scoped lang="scss">
  .logo{
    display: flex;
    align-items: flex-end;
    justify-content: center;
    span{
      font-size: 2rem;
      font-family: 'LaTercera', sans-serif;
      text-transform: uppercase;
      color: transparent;
      letter-spacing: 0.2rem;
      text-align: center;
      display: block;
      background: linear-gradient(90deg, #30a3e5,  #e9008b, #30a3e5);
      background-size: 200% 200%;
      animation: Transicion 1.3s ease infinite;
      background-clip: text;
      -webkit-background-clip: text;
      animation-play-state: paused;
      &.moving{
        animation-play-state: running;
      }
    }
  }

  @keyframes Transicion {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
  }
</style>
